import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

// Development mode flag - set to false to enable real authentication
const DEV_MODE = false;

const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading && !DEV_MODE) {
    return <div>Loading...</div>;
  }

  // In development mode, always render the children regardless of authentication status
  if (DEV_MODE) {
    console.log('DEV MODE: Bypassing authentication check for public route');
    return children;
  }

  // Only check authentication in production mode
  if (isAuthenticated) {
    return <Navigate to="/" />;
  }

  return children;
};

export default PublicRoute;